import { render, staticRenderFns } from "./PurL_Search.vue?vue&type=template&id=09a8083e"
import script from "./PurL_Search.vue?vue&type=script&lang=js"
export * from "./PurL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports